import React, { Component } from "react"
import {
  Card,
  CardContent,
  CardActions,
  Divider,
  Typography,
  Button,
  Grid,
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import CrewCard from "../CrewCard"
import PlaceIcon from "@material-ui/icons/Place"
import EliteImage from "../../assets/images/elite1.png"
import Rating from "../Rating"

class Legend extends Component {
  render() {
    const { classes, open, close } = this.props
    return (
      <div className={open ? classes.legendOpen : classes.legend}>
        <Card className={classes.card}>
          <CardActions>
            <Typography variant="h5">How it Works</Typography>
            <div style={{ flexGrow: 1 }} />
            <Button color="primary" variant="contained" onClick={close}>
              Got it
            </Button>
          </CardActions>
          {/* <div className={classes.title}>
            <Typography variant="h6">How it Works</Typography>
            <Button color="primary" variant="contained">
              Got it
            </Button>
          </div> */}
          <Divider />
          <CardContent className={classes.legendContent}>
            {/* card content */}
            <Grid container spacing={4}>
              <Grid
                item
                sm={6}
                xs={12}
                className={this.props.classes.centerContent}
              >
                <div className={classes.crewCard}>
                  <CrewCard
                    crew={{
                      roles: [],
                      ratings: [],
                      companies: [],
                      badges: [true],
                      equipment: [],
                      vehicles: [],
                      locations: [{ label: "Atlanta, GA", city: "Atlanta" }],
                      membershipValid: true,
                      first_name: "Sammy",
                      last_name: "Sound",
                    }}
                  />
                </div>
              </Grid>
              <Grid item sm={6} xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.sectionName}
                >
                  Crew Profile Cards
                </Typography>
                <Typography>
                  Your Crew Profile Card is what gets displayed to bookers on
                  Crew Mama. Make sure you fill your profile card out completely
                  with your position, equipment, and location to rank higher in
                  the search results.
                </Typography>
              </Grid>
            </Grid>
            {/* name and location content */}
            <Grid container spacing={4} className={classes.mobileColumnReverse}>
              <Grid item sm={6} xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.sectionName}
                >
                  Crew Member Name and Location
                </Typography>
                <Typography>
                  This section is where your name and location service area will
                  be displayed. Make sure your name and location information is
                  accurate to book more shoots.
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                xs={12}
                className={this.props.classes.centerContent}
              >
                <Card>
                  <CardContent>
                    <Typography
                      variant="h6"
                      gutterBottom
                      className={classes.sectionName}
                    >
                      Sammy Sound
                    </Typography>
                    <CardActions style={{ margin: 0 }}>
                      <PlaceIcon className={this.props.classes.placeIcon} />
                      <Typography
                        variant="caption"
                        className={this.props.classes.placeName}
                        color="inherit"
                      >
                        Atlanta, GA
                      </Typography>
                    </CardActions>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* elite status content */}
            <Grid container spacing={4} className={classes.mobileColumnReverse}>
              <Grid item sm={6} xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.sectionName}
                >
                  Elite Status
                </Typography>
                <Typography>
                  The Elite badge is available to crew members who have paid the
                  $300.00 annual rate and had their profiles verified by
                  Crew Mama admins. Elite status pushes you to the top of search
                  results regardless of your community ranking.
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                xs={12}
                className={this.props.classes.centerContent}
              >
                <div className={this.props.classes.badgeWrapper}>
                  <img
                    src={EliteImage}
                    className={this.props.classes.badgeImage}
                    alt="Elite"
                  />
                </div>
              </Grid>
            </Grid>

            {/* Reel | Equipment | Vehicles content */}
            <Grid container spacing={4} className={classes.mobileColumnReverse}>
              <Grid item sm={6} xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.sectionName}
                >
                  Reel | Equipment | Vehicles
                </Typography>
                <Typography>
                  This area is where you will be able to provide a link to your
                  reel or online portfolio. You will also be able to list out
                  any equipment and gear you own to make sure you are the right
                  fit for an upcoming shoot. Vehicles can also be listed here so
                  bookers can determine if additional gear can be rented and
                  picked up for a shoot.
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                xs={12}
                className={this.props.classes.centerContent}
              >
                <div className={classes.icons}>
                  <i className={"icon-reel " + this.props.classes.boxIcon} />
                  <i className={"icon-box " + this.props.classes.boxIcon} />
                  <i className={"icon-vehicle " + this.props.classes.boxIcon} />
                </div>
              </Grid>
            </Grid>

            {/* Rating System content */}
            <Grid container spacing={4} className={classes.mobileColumnReverse}>
              <Grid item sm={6} xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.sectionName}
                >
                  Rating System
                </Typography>
                <Typography>
                  Crew Mama ranks crew profiles based on a double-tiered rating
                  system: community ranking and individual ranking. Your
                  community ranking will be displayed on your profile card
                  within a search result to help bookers determine if you are
                  the right fit for an upcoming project.
                </Typography>
              </Grid>
              <Grid
                sm={6}
                xs={12}
                item
                className={this.props.classes.centerContent}
              >
                <div className={this.props.classes.rating}>
                  <Rating
                    avgRating={4.8}
                    totalRatings={18}
                    selectedRating={4}
                    userId={0}
                    ratingChanged={() => ""}
                  />
                </div>
              </Grid>
            </Grid>

            {/* Booking content */}
            <Grid container spacing={4} className={classes.mobileColumnReverse}>
              <Grid item sm={6} xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  className={classes.sectionName}
                >
                  Book a Crew Member
                </Typography>
                <Typography>
                  The Book a Crew Member Button on a profile allows you to
                  contact and book a crew member directly on a shoot. No hassle
                  of a 3rd party, or extensive vetting process. Just click and
                  book!
                </Typography>
              </Grid>
              <Grid
                item
                sm={6}
                xs={12}
                className={this.props.classes.centerContent}
              >
                <Button color="primary" variant="contained" size="large">
                  Book
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default withStyles(styles)(Legend)
